import styled from 'styled-components'

export const PublicPageWrapper = styled.div`
	max-width: 1080px;
	margin: 16px auto;
	padding: 20px;
`

export const PublicPageHeader = styled.div`
	position: relative;
	padding-bottom: 16px;
	margin-bottom: 32px;
	border-bottom: 1px solid #c6ccd6;
`
